import styled, { keyframes } from "styled-components";
import { ToastFeedbackType } from "./types";

const enter = keyframes`
  from {
    opacity: 0;
    transform: translateY(-12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Toast = styled.div<{ $type: ToastFeedbackType }>`
  position: fixed;
  top: ${({ theme }) => theme.spacing(4)};
  right: ${({ theme }) => theme.spacing(4)};
  z-index: 1000;
  width: min(420px, calc(100vw - 32px));
  min-height: 52px;
  padding: ${({ theme }) => theme.spacing(3)} ${({ theme }) => theme.spacing(4)};
  border: 1px solid
    ${({ theme, $type }) =>
      $type === "success" ? theme.colors.green : theme.colors.lightRed};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ $type }) => ($type === "success" ? "#f2fff7" : "#fff7f6")};
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
  color: ${({ theme, $type }) =>
    $type === "success" ? theme.colors.darkGreen : theme.colors.red};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  animation: ${enter} 0.2s ease-out;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    right: 16px;
    left: 16px;
    width: auto;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Message = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;

export const CloseButton = styled.button`
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background: transparent;
  color: currentColor;
  font: inherit;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: rgb(0 0 0 / 6%);
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
`;
